import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import { PermissionProvider } from './context/PermissionContext'
import { NotificationProvider } from './context/NotificationContext'
import { BrandingProvider } from './context/BrandingContext'
import { ThemeModeProvider } from './context/ThemeModeContext'
import './styles/index.css'

// Register the app-shell service worker so the app is installable (PWA) and
// loads fast. Production only — a service worker intercepting module requests
// would interfere with Vite's dev HMR. Registered here (a bundled, same-origin
// module) to satisfy the strict CSP (`script-src 'self'`, no inline scripts).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Registration failures are non-fatal — the app still works online.
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeModeProvider>
        <BrandingProvider>
          <AuthProvider>
            <PermissionProvider>
              <NotificationProvider>
                <App />
                <ToastContainer
                  position="top-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
              </NotificationProvider>
            </PermissionProvider>
          </AuthProvider>
        </BrandingProvider>
      </ThemeModeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
